module.exports = __webpack_public_path__ + "img/right-arrow.780f047d.svg";